<template>
    <div class="page-content" id="ppes-list">
        <Titlebar :incrustation="'fa-shield'">
            <h1>{{ $t('ppes.titles.list') }}</h1>
        </Titlebar>
        <div class="alert alert-info mb-4">
            <p v-html="$t('ppes.description.content', {univers: Utils().getApplicationName()})" class="mb-1"></p>
            <ul class="m-0">
                <li v-html="$t('ppes.description.list1')"></li>
                <li v-html="$t('ppes.description.list2')"></li>
            </ul>
        </div>
        <UiCard>
            <SuperTable
                :tableColumns="tableColumns"
                :tableData="tableData"
                @sort="handleSort"
                @filter="handleFilter"
                @copy="handleCopy"
                @delete="handleDelete"
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                    <Btn class="primary" v-can="'beepiz-add-ppes'">
                        <router-link to="/parameters/ppes/new" tag="span"><i class="fa fa-plus"></i><span>{{ $t('ppes.btns.add') }}</span>
                        </router-link>
                    </Btn>
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Globals from '@/services/globals.js';
    import Auth from '@/services/auth.js'
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import Pagination from "@/components/ui/Pagination";
    import SuperTable from "@/components/ui/Table";
    import Utils from '@/services/utils.js'

    import UserRenderer from "@/components/identifications/TableRowUserRenderer";
    import {useDvFlag, useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'PPEsList',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            Pagination,
            SuperTable
        },
        data: () => ({
            count: 0,
            config: {
                perpage: Globals.perPage,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: []
            },
            tableColumns: {
                global: {
                    sortable: false,
                    noItemsMsg: window.V.$i18n.t('ppes.emptyTable')
                },
                columns: [
                    {
                        key: 'name',
                        label: window.V.$i18n.t('ppes.cols.name'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        linkTo: useDvFlagAccess('beepiz-ppe-list-can:update') ? '/parameters/ppes/:id' : null,
                        width: '25%'
                    },
                    {
                        key: 'mode',
                        label: window.V.$i18n.t('ppes.cols.mode'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: false,
                        width: '12%',
                        showTooltip: true,
                        tooltipTitle:Utils.t('ppes.tooltip.title'),
                        tooltipContent:Utils.t('ppes.tooltip.content',{univers: Utils.getApplicationName()}),
                        renderer(item){
                            return item.mode === 1 ? Utils.t('ppes.verification.all') : Utils.t('ppes.verification.missing')
                        }
                    },
                    {
                        key: 'mailNotification',
                        label: window.V.$i18n.t('ppes.cols.notification'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: false,
                        width: '7%',
                        renderer(item){
                            return item.mailNotification === 1 ? '<i class="fa fa-envelope text-gray-600 text-2xl"></i>' : ''
                        }
                    },
                    {
                        key: 'ppes',
                        label: window.V.$i18n.t('ppes.cols.epis'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: false,
                        width: '40%',
                        renderer(item){
                            let epis = ''
                            item.ppes.forEach(epiItem => {
                                epis += '<span class="ppe ppe'+epiItem.id+' mt-1" title="'+epiItem.name+'"></span>'
                            })
                            return epis
                        }
                    }
                ],
                rowActions: {
                    width: '10%',
                    actions: [
                        {
                            label: Utils.t('global.copy'),
                            class: 'fa fa-copy',
                            event: 'copy'
                        },
                        {
                            label: Utils.t('global.delete'),
                            class: 'fa fa-trash',
                            event: 'delete'
                        }
                    ]
                }
            },
            tableData: [
                /*{
                    "id": 1,
                    "name": "Ma super liste d'EPIs",
                    "mode": 1,
                    "mailNotification" : 1,
                    "epis": [
                        1,
                        3,
                        7,
                        10
                    ]
                },
                {
                    "id": 2,
                    "name": "Mon autre liste",
                    "mode": 0,
                    "mailNotification" : 0,
                    "epis": [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15
                    ]
                }*/
            ]
        }),

        created(){

        },
        mounted(){
          const flag = useDvFlag('beepiz-ppe-list-can:read');
          if (!flag.access && flag.fallback==="no_plan") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "ppes"} })
          }
          else if (!flag.access && flag.fallback==="no_role") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "ppes_no_role"} })
          }else {
                if(!useDvFlagAccess('beepiz-ppe-list-can:delete')){
                    this.tableColumns.rowActions.actions.splice(1,1);
                }

                if(!useDvFlagAccess('beepiz-ppe-list-can:create')){
                    this.tableColumns.rowActions.actions.splice(0,1);
                }
                this.loadData();
            }
        },
        methods: {
            Utils() {
                return Utils
            },
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter != '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            handleCopy: function(item){
                window.V._router.push('/parameters/ppes/'+item.id+'/copy');
            },
            handleDelete: function(item){
                var vThis = this;
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.t('global.deleteModalContent'),
                    callbackYes: function () {
                        axios.delete(API.route(API.endpoints.ppes.delete, {id: item.id}))
                            .then(response => {
                                if(vThis.tableData.length == 1 && vThis.config.page > 1){
                                    vThis.config.page--;
                                }
                                vThis.loadData();
                            })
                            .catch(error => {
                                window.Vfc.$refs.messages.sendMessage('error', error.response.data.message);
                            })
                    }
                });
            },
            loadData: function(){
                axios.get(API.endpoints.ppes.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.tableData = response.data.data;
                        this.count = response.data.meta.pagination.total;
                        this.$refs.pagination.update(response.data.meta.pagination);
                        window.Vfc.$refs.loading.hide();
                    })
            }
        }
    }
</script>

<style lang="scss">
  #ppes-list {
    .ppe{
        margin-right: 5px;
    }
    .fa-envelope {
        font-size: 1.7rem;
    }
  }
  .module-description-wrapper{
    background: rgba(255,193,7,0.1);
    border: 1px solid rgba(0,0,0,0.1);
    padding: 10px;
    margin-bottom: 15px;
    width: 100%;
    h4{
      font-size: 1.3rem;
      margin-bottom: 0;
    }
    ul{
      margin: 0;
    }
    li{
      font-size: 1rem;
    }
  }
  body.sfr .module-description-wrapper, body.catsafe .module-description-wrapper{
    background: #F0F0F0;
  }
</style>
